import React from 'react';
import { CHIP_ICON_POSITION, CHIP_SIZE, CHIP_TYPE } from '../../../global/constants';
import Chip from '../../chipComponent';

interface ChipMenuTriggerProps {
  title: string;
  isOpen: boolean;
  onClick: () => void;
}

const ChipMenuTrigger: React.FC<ChipMenuTriggerProps> = ({ title, isOpen, onClick }) => (
  <Chip
    variant={CHIP_TYPE.FILL}
    size={CHIP_SIZE.SMALL}
    title={title}
    onClick={onClick}
    isActive={isOpen}
    trailingIconName='down-arrow-icon'
    trailingIconClassName={isOpen ? 'dropdown-icon' : ''}
    iconPosition={CHIP_ICON_POSITION.TEXT_RIGHT_BUTTON}
  />
);

export default ChipMenuTrigger;
